export default __webpack_public_path__ + "static/media/facebook.f37142b6.svg";